export const classNames = (...classNames: Array<string | undefined | null>) => classNames.filter(Boolean).join(' ');

export const hyphenateAndLowercase = (str: string): string => {
  const stringArr = str.split('');
  // lowercase the first letter
  const result = [stringArr[0].toLowerCase()];
  // then parse rest of the string
  for (let i = 1; i < stringArr.length; i++) {
    const letter = stringArr[i];
    if (letter.match(/[A-Z]/)) {
      result.push(`-${letter.toLowerCase()}`);
    } else {
      result.push(letter);
    }
  }
  return result.join('');
};
